// prescriptions-errors.data.ts
//
// Repeat prescription and EPS.

import { ErrorEntry } from './error-metadata.types';

export const prescriptionsErrors = {
  'no-repeat-medication-found': {
    message: 'No repeat medications are available to request.',
    title: 'Unable to proceed',
  },
  'eps-unavailable-exception': {
    message:
      'We’re having trouble connecting to the NHS Electronic Prescription Service. Please try again or come back later.',
    title: 'EPS unavailable',
  },
} satisfies Record<string, ErrorEntry>;
